import * as Yup from "yup";

export const blogValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  slug: Yup.string().required("Slug is required"),
  summary: Yup.string().required("Summary is required"),
  content: Yup.string().required("Content is required"),
  // author_id: Yup.number().required("Author is required"),
  category_id: Yup.number().required("Category is required"),
});
